import { gql } from '@apollo/client';

export const EDIT_TV_APP_CONFIGURATION_MUTATION = gql`
  mutation EditTvAppConfiguration($data: updateTvAppConfigurationInput!) {
    updateTvAppConfiguration(input: $data) {
      tvAppConfiguration {
        id
        order
        slug
        name
        surroundingInformationCategories {
          id
          title
          locale
          localizations {
            id
            locale
            title
          }
        }
        stayInformations {
          id
          title
          locale
          localizations {
            id
            locale
            title
          }
        }
      }
    }
  }
`;
